export const PLAN_ID = {
  FREE: 0,
  STARTER: 1,
  EARLIER: 2,
};
export const CLICK_ACTION_ERROR = {
  ELEMENT_VALUE_IS_INVALID: 'ELEMENT_VALUE_IS_INVALID',
  REQUIRED_VALUE: 'REQUIRED_VALUE',
};

export const ELEMENT_ERROR_TEXT = {
  [CLICK_ACTION_ERROR.REQUIRED_VALUE]: 'elementError.required',
};
